import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink, Navigate } from 'react-router-dom';
import { t } from '@/core/localization';
import { tDynamic } from '@/core/localization/t';
import { ProtectedRoute } from '../components';
// TODO: to delete later. Placement section must be deleted.
export const placementRoutes = [
    {
        path: 'placement',
        element: _jsx(Navigate, { to: "receipted", replace: true }),
    },
    {
        path: 'placement',
        lazy: async () => {
            const { Placement } = await import('@/warehouse/modules/placement');
            return {
                element: (_jsx(ProtectedRoute, { claims: ['Warehouse'], groups: ['crossdocking'], children: _jsx(Placement, {}) })),
            };
        },
        handle: {
            crumb: () => _jsx(NavLink, { to: "/placement/receipted", children: t('placement.label') }),
        },
        children: [
            {
                path: ':tab',
                lazy: async () => {
                    const { Placement } = await import('@/warehouse/modules/placement');
                    return { Component: Placement };
                },
                handle: {
                    crumb: ({ params: { tab } }) => _jsx(NavLink, { to: `/placement/${tab}`, children: tDynamic(`${tab}.label`) }),
                },
            },
        ],
    },
];
